import React from 'react'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Typography from '@mui/material/Typography'

type StatTileProps = {
  label: string
  value: React.ReactNode
  caption?: string
  color?: string
}

const StatTile: React.FC<StatTileProps> = ({ label, value, caption, color }) => (
  <Card variant="outlined" sx={{ height: '100%' }}>
    <CardContent>
      <Typography
        variant="overline"
        color="text.secondary"
        sx={{ display: 'block', lineHeight: 1.4 }}
      >
        {label}
      </Typography>
      <Typography variant="h5" sx={{ fontWeight: 700, color: color || 'text.primary' }}>
        {value}
      </Typography>
      {caption && (
        <Typography variant="body2" color="text.secondary">
          {caption}
        </Typography>
      )}
    </CardContent>
  </Card>
)

export default StatTile
